// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"uQ-z","smallCardRow":"vQ-z","largeCardRow":"wQ-z","productSearchRow":"xQ-z","curatedRow":"yQ-z"};